import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {WP_REST_API_Attachment, WP_REST_API_Post, WP_Term} from "wp-types";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {MediaAttachmentComponent} from "../media-attachment/media-attachment.component";
import {RouterLink} from "@angular/router";
import {PageExtended} from "../../../models/Page/PageExtended";

@Component({
  selector: 'tiny-post',
  standalone: true,
  imports: [CommonModule, AttachmentFromIdPipe, MediaAttachmentComponent, RouterLink],
  templateUrl: './tiny-post.component.html',
  styleUrl: './tiny-post.component.scss'
})
export class TinyPostComponent implements OnChanges{
  @Input() post: PageExtended | null;
  @Input() title?: string = undefined;
  @Output() pageCategoriesChange = new EventEmitter<WP_Term[]>();
  sizeXL : number = 15
  sizeLG : number = 15;
  sizeMD : number = 15;
  sizeSM : number = 15;
  sizeXS : number = 15;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['post'].isFirstChange()){
      this.pageCategoriesChange.emit(this.post?.page_categories)
    }
  }
}
